import Vue from 'vue';
// prettier-ignore
const state = Vue.observable({
    globalError: null,
    goBackUrl: null
});
export default state;
